var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.23,
    height: 32.23,
    viewBox: "0 0 32.23 32.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(-6719.828 3205.528)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 15.615,
    cy: 15.615,
    r: 15.615,
    transform: "translate(6720.328 -3205.028)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5671",
    "data-name": "Group 5671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5670",
    "data-name": "Group 5670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7984",
    "data-name": "Path 7984",
    d: "M6733.748-3190.877v-.647a6.638,6.638,0,0,1,.76-.238q.476-.123,1.008-.218t1.056-.162a7.488,7.488,0,0,1,.922-.066l.343.227-1.712,8.159h1.331v.663a3.725,3.725,0,0,1-.58.332,5.682,5.682,0,0,1-.7.273,6.2,6.2,0,0,1-.751.185,4.061,4.061,0,0,1-.722.069,1.405,1.405,0,0,1-1-.276.835.835,0,0,1-.276-.6,4.744,4.744,0,0,1,.057-.742q.057-.361.152-.8l1.293-5.9Zm1.6-4.279a1.235,1.235,0,0,1,.438-1.008,1.668,1.668,0,0,1,1.1-.361,1.726,1.726,0,0,1,1.151.361,1.249,1.249,0,0,1,.427,1.008,1.205,1.205,0,0,1-.427.97,1.726,1.726,0,0,1-1.151.361,1.668,1.668,0,0,1-1.1-.361A1.192,1.192,0,0,1,6735.345-3195.156Z",
    fill: "#040505"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i-icon.bf8c5ff9808015cb54586b3ca5bc85fb.svg";
export { ForwardRef as ReactComponent };